import React, { Component } from 'react'

export default class Sidebar extends Component {
  render() {
    return (
      <div>
        <div>
          <nav href="#navbar" className="js-colorlib-nav-toggle colorlib-nav-toggle" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar"><i /></nav>
          <aside id="colorlib-aside" className="border js-fullheight">
            <div className="text-center">
              <div className="author-img" style={{backgroundImage: 'url(images/lolu.jpg)'}} />
              <h1 id="colorlib-logo"><a href="index.html">Lolu Aguda</a></h1>
              <span className="email"><i className="icon-mail"></i> akinlolu@loagsmedia.com</span>
            </div>
            <nav id="colorlib-main-menu" role="navigation" className="navbar">
              <div id="navbar" className="collapse">
                <ul>
                  <li className="active"><a href="#home" data-nav-section="home">Me</a></li>
                  <li><a href="#about" data-nav-section="about">About</a></li>
                  <li><a href="#projects" data-nav-section="projects">Projects</a></li>
                  <li><a href="#timeline" data-nav-section="timeline">Timeline</a></li>
                  {/* <li>
                    <a href="https://drive.google.com/file/d/1ucMGnSYKpMbhNw_Z5LtrrE_q9JlAGAEV/view?usp=sharing" target="_blank" rel="noopener noreferrer">Resume ~</a>
                  </li> */}
                </ul>
              </div>
            </nav>
            <nav id="colorlib-main-menu">
              <ul>
                <li><a href="https://www.linkedin.com/in/akinlolu-aguda/" target="_blank" rel="noopener noreferrer"><i className="icon-linkedin2" /></a></li>
                <li><a href="https://github.com/loagsword" target="_blank" rel="noopener noreferrer"><i className="icon-github"></i>  </a></li>
                
              </ul>
            </nav>
            <div className="colorlib-footer">
              <p><small>
                Built on React.<br />
                UI by ©<a href="https://colorlib.com" target="_blank" rel="noopener noreferrer">Colorlib</a>.
              </small></p>
            </div>
            
          </aside>
        </div>
      </div>
    )
  }
}
